import PropTypes from 'prop-types';
import React from 'react';

import fontConstants from '@cdo/apps/fontConstants';
import i18n from '@cdo/locale';

import {
  SOUND_PREFIX,
  DEFAULT_SOUND_PATH_PREFIX,
} from '../../assetManagement/assetPrefix';
import Sounds from '../../Sounds';
import color from '../../util/color';

import AssetManager from './AssetManager';
import {RecordingFileType} from './recorders';
import SoundLibrary from './SoundLibrary';

const audioExtension = '.mp3';

const MODE = {
  files: 'files',
  sounds: 'sounds',
};

/**
 * A component for managing hosted sounds and the Sound Library.
 */
export default class SoundPicker extends React.Component {
  static propTypes = {
    assetChosen: PropTypes.func,
    assetsChanged: PropTypes.func,
    typeFilter: PropTypes.string,
    uploadsEnabled: PropTypes.bool.isRequired,
    showUnderageWarning: PropTypes.bool.isRequired,
    useFilesApi: PropTypes.bool.isRequired,
    libraryOnly: PropTypes.bool,
    //For logging upload failures
    projectId: PropTypes.string,
    soundPlayer: PropTypes.object,
  };

  state = {mode: MODE.sounds};

  getAssetNameWithPrefix = sound => {
    const soundName = sound.replace(DEFAULT_SOUND_PATH_PREFIX, SOUND_PREFIX);
    this.props.assetChosen(soundName);
  };

  setSoundMode = () => this.setState({mode: MODE.sounds});

  setFileMode = () => {
    let sounds = Sounds.getSingleton();
    sounds.stopAllAudio();
    this.setState({mode: MODE.files});
  };

  render() {
    const isFileMode = this.state.mode === MODE.files;
    const modeSwitchButtonBase = {
      fontSize: 16,
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      padding: 0,
    };
    const headerStyles = {
      soundModeToggle: {
        ...modeSwitchButtonBase,
        float: 'left',
        margin: '0 20px 0 0',
      },
      fileModeToggle: {
        ...modeSwitchButtonBase,
        margin: 0,
      },
    };

    if (isFileMode) {
      headerStyles.soundModeToggle = {
        ...headerStyles.soundModeToggle,
        color: color.light_gray,
      };

      headerStyles.fileModeToggle = {
        ...headerStyles.fileModeToggle,
        ...fontConstants['main-font-semi-bold'],
      };
    } else {
      headerStyles.soundModeToggle = {
        ...headerStyles.soundModeToggle,
        ...fontConstants['main-font-semi-bold'],
      };
      headerStyles.fileModeToggle = {
        ...headerStyles.fileModeToggle,
        color: color.light_gray,
      };
    }

    let modeSwitch;
    let title = <p>{i18n.chooseSounds()}</p>;

    modeSwitch = (
      <div id="modeSwitch">
        <button
          type="button"
          onClick={this.setSoundMode}
          style={headerStyles.soundModeToggle}
        >
          {i18n.soundLibrary()}
        </button>
        <button
          type="button"
          onClick={this.setFileMode}
          style={headerStyles.fileModeToggle}
        >
          {i18n.makeNewSounds()}
        </button>
      </div>
    );

    const displaySoundLibraryTab = this.state.mode === MODE.sounds;
    const body =
      this.libraryOnly || displaySoundLibraryTab ? (
        <SoundLibrary assetChosen={this.getAssetNameWithPrefix} />
      ) : (
        <AssetManager
          assetChosen={this.props.assetChosen}
          assetsChanged={this.props.assetsChanged}
          allowedExtensions={audioExtension}
          uploadsEnabled={this.props.uploadsEnabled}
          useFilesApi={this.props.useFilesApi}
          projectId={this.props.projectId}
          soundPlayer={this.props.soundPlayer}
          recordingFileType={RecordingFileType.MP3}
        />
      );
    return (
      <div className="modal-content" style={styles.root}>
        {title}
        {!this.props.libraryOnly && (
          <div>
            {this.props.showUnderageWarning && (
              <p style={styles.warning}>
                Warning: Do not upload anything that contains personal
                information.
              </p>
            )}
            {modeSwitch}
          </div>
        )}
        <hr style={styles.divider} />
        {body}
      </div>
    );
  }
}

const styles = {
  root: {
    margin: '0 0 0 5px',
  },
  divider: {
    borderColor: color.purple,
    margin: '5px 0',
  },
  warning: {
    color: color.red,
    fontSize: 13,
    fontWeight: 'bold',
  },
};
